export const Wint = "Wint";
export const DefaultTableRowCount = 20;
export const OrganizationNumberMask = "######-####";
export const OrganizationNumberLength = 10;
export const PersonNumberMask = "######-####";
export const PersonNumberSimpleMask = "############";
export const PersonNumberLongMask = "########-####";
export const PhoneNumberMask = "###-########";
export const OldSKUrl = "https://app.wint.se/";
export const WelcomeGuideId = "web3-index";
export const MobileAppPromotionId = "mobile-app-promotion";
export const RevenueReportingCreateDialogId = "revenue-reporting-create-dialog";
export const SupportEmailAddress = "support@wint.se";
export const MinimumExpectedAge = 15;
export const HoursSymbol = "h";
export const ExcelFileExtension = "xlsx";
export const FormFieldPlaceholderMaxLength = 40;

export const SuccessIndicatorDurationMs = 1450;
export const DialogTransitionDurationMs = 300;

export const EmptyGuid: string = "00000000-0000-0000-0000-000000000000";

export const SelectAllSelectionId = "__SELECT_ALL__";
